export const provisioningContent = `# Provisioning

Set up your Lightswitch environment using the admin panel (coming soon):

* **Tenant** → Your organization/account
* **App** → Your product instance with API credentials
* **\`has_access\` FeatureDefinition** → Boolean entitlement gate
* **SKU mapping** → Maps purchases to \`has_access: true\`
* **Onboarding/Login flows** → User journey configuration

**Generated outputs:**
* **Publishable key** (\`pk_...\`) → Use in frontend LightswitchProvider
* **appSlug** → Your app identifier

**Security reminders:**
* Rotate default keys in production
* Update callback URLs to your domain`;
